var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2569_7340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 0H4.6875C2.09867 0 0 2.09867 0 4.6875V20.3125C0 22.9013 2.09867 25 4.6875 25H20.3125C22.9013 25 25 22.9013 25 20.3125V4.6875C25 2.09867 22.9013 0 20.3125 0Z",
    fill: "#0177B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9688 6.25H7.03125C6.82405 6.25 6.62534 6.33231 6.47882 6.47882C6.33231 6.62534 6.25 6.82405 6.25 7.03125V17.9688C6.25 18.176 6.33231 18.3747 6.47882 18.5212C6.62534 18.6677 6.82405 18.75 7.03125 18.75H17.9688C18.176 18.75 18.3747 18.6677 18.5212 18.5212C18.6677 18.3747 18.75 18.176 18.75 17.9688V7.03125C18.75 6.82405 18.6677 6.62534 18.5212 6.47882C18.3747 6.33231 18.176 6.25 17.9688 6.25ZM10.1562 16.7969H8.20312V10.9375H10.1562V16.7969ZM9.17969 10.1562C8.94791 10.1562 8.72134 10.0875 8.52863 9.95875C8.33592 9.82999 8.18571 9.64696 8.09702 9.43283C8.00832 9.2187 7.98511 8.98307 8.03033 8.75575C8.07555 8.52843 8.18716 8.31962 8.35105 8.15573C8.51494 7.99184 8.72374 7.88023 8.95107 7.83502C9.17839 7.7898 9.41401 7.81301 9.62814 7.9017C9.84228 7.9904 10.0253 8.1406 10.1541 8.33332C10.2828 8.52603 10.3516 8.7526 10.3516 8.98438C10.3516 9.29518 10.2281 9.59325 10.0083 9.81302C9.78856 10.0328 9.49049 10.1562 9.17969 10.1562ZM16.7969 16.7969H14.8438V12.8906C14.8438 12.5664 14.4062 12.3047 13.8672 12.3047C13.0859 12.3047 12.8906 13.3477 12.8906 13.6719V16.7969H10.9375V10.9375H12.8906V12.3047C12.8906 11.3281 13.7656 10.9375 14.8438 10.9375C15.3618 10.9375 15.8585 11.1433 16.2248 11.5096C16.5911 11.8758 16.7969 12.3726 16.7969 12.8906V16.7969Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2569_7340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d9c9b2e4c25d083e039346f7b0d5132c.svg";
export { ForwardRef as ReactComponent };